import React from "react"
import type { NodeViewProps } from "@tiptap/react"
import { NodeViewWrapper } from "@tiptap/react"
import "./file-node.scss"

const formatFileSize = (bytes: number | null | undefined): string => {
  if (!bytes || bytes === 0) return ""
  const k = 1024
  const sizes = ["Bytes", "KB", "MB", "GB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
}

const getFileExtension = (fileName: string): string => {
  return fileName.split(".").pop()?.toLowerCase() || ""
}

export const FileNode: React.FC<NodeViewProps> = ({ node, selected, deleteNode }) => {
  const { src, fileName, fileSize } = node.attrs

  const extension = getFileExtension(fileName || "")
  const formattedSize = formatFileSize(fileSize)

  const handleDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    
    // Для base64 создаем blob и скачиваем
    if (src.startsWith("data:")) {
      const link = document.createElement("a")
      link.href = src
      link.download = fileName || "file"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else {
      // Для обычных URL открываем в новой вкладке
      window.open(src, "_blank")
    }
  }

  const handleDelete = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    
    if (deleteNode && window.confirm("Вы уверены, что хотите удалить этот файл?")) {
      deleteNode()
    }
  }

  return (
    <NodeViewWrapper 
      className={`file-node-wrapper ${selected ? "selected" : ""}`}
      data-drag-handle
    >
      <div className="file-node">
        <button 
          className="file-node-delete" 
          onClick={handleDelete}
          aria-label="Удалить файл"
        >
          ✕
        </button>
        <div className="file-node-icon">
          <span className="file-node-extension">{extension}</span>
        </div>
        <div className="file-node-info">
          <span className="file-node-name">{fileName}</span>
          {formattedSize && <span className="file-node-size">{formattedSize}</span>}
        </div>
        <button className="file-node-download" onClick={handleDownload}>
          Скачать
        </button>
      </div>
    </NodeViewWrapper>
  )
}

export default FileNode
